import { useLocale } from '../../preferences/i18n/LocaleProvider';

export function ValidationHintList({ hints }: { hints: string[] }) {
	const { t } = useLocale();
	if (!hints.length) return null;
	return <ul role="alert">{hints.map((hint) => <li key={hint}>{translateHint(hint, t)}</li>)}</ul>;
}

function translateHint(hint: string, t: ReturnType<typeof useLocale>['t']): string {
	switch (hint) {
		case 'Display name is required.':
			return t('validationDisplayNameRequired');
		case 'Custom field label is required.':
			return t('validationCustomFieldLabelRequired');
		case 'Custom field ids must be unique.':
			return t('validationCustomFieldIdsUnique');
		case 'Tags can only contain letters, numbers, and spaces. Use commas to separate multiple tags.':
			return t('validationTagsInvalid');
		case 'Project cannot reference itself.':
			return t('validationProjectSelfReference');
		default:
			return hint;
	}
}
